import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iis-cdp-backup',
  templateUrl: './iis-cdp-backup.component.html',
  styleUrls: ['./iis-cdp-backup.component.css']
})
export class IisCdpBackupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
